export default "__VITE_ASSET__Gbyj8dAVPP$N5n3vBvuBIg__"